import React, { useState } from "react";
import LogoutIcon from "@mui/icons-material/Logout";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { logout } from "../redux/userSlice";
import UplaodImg from "../components/UploadImg";
import { useNavigate } from "react-router-dom";

const Container = styled.div`
  padding: 10px 15px;
  width: 150px;
  height: max-content;
  position: fixed;
  top: 5px;
  right: 200px;
  border-radius: 3px;
  border: 1px solid ${({ theme }) => theme.soft};
  background-color: ${({ theme }) => theme.bgLighter};
  color: ${({ theme }) => theme.text};
  z-index: 9999;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
const Item = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 10px;
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.soft};
  }
`;

const LogoutModal = ({ setOpenModal, currentUser }) => {
  const [openImgModal, setOpenImgModal] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.preventDefault();
    setOpenModal(false);
    dispatch(logout());
  };

  const handleChangePhoto = (e) => {
    e.preventDefault();
    document.body.style.overflow = 'hidden';
    setOpenImgModal(true);
  };
  const handleMyVideo = (e) => {
    e.preventDefault();
    navigate(`/profile/${currentUser?._id}`);
    setOpenModal(false);
  };

  return (
    <>
      <Container>
        <Wrapper>
          <Item onClick={handleClick}>
            <LogoutIcon /> Logout
          </Item>
          <Item onClick={handleChangePhoto}>
            <AddAPhotoIcon /> Change Profile Photo
          </Item>
          <Item onClick={handleMyVideo}>
            <VideoLibraryIcon /> My Videos
          </Item>
        </Wrapper>
      </Container>
      {openImgModal && (
        <UplaodImg
          setOpenImgModal={setOpenImgModal}
          setOpenModal={setOpenModal}
        />
      )}
    </>
  );
};

export default LogoutModal;
